import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

// Where "/" (and any unknown URL) lands, per role: the queue for the people who validate, the DMP
// console for a Build account. Hardcoding /address-validations meant a Build user's first click —
// or the SSO landing — bounced off a guard and read as a refusal (user ask 2026-08-07).
export function HomeRedirect() {
  const { isInternal } = useAuth();
  return <Navigate to={isInternal ? '/address-validations' : '/dmp-console'} replace />;
}
